import { gql } from "@apollo/client";

export const listHorses = gql`
  query listHorses {
    listHorses {
      count
      items {
        color
        createdAt
        dob
        height
        id
        name
        owner {
          name
          email
        }
        photo
        scannedAt
        status
        updatedAt
        weight
        discipline
        measurements {
          gulletWidth
          gulletHeight
          barAngle
          swayHeight
        }
        isDeleted
        registeredName
      }
      nextToken
    }
  }
`;
